import {post} from '@/utils/request';
import {erpserver,attendanceserver} from '@/utils/baseUrl';
//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}
//保存方案列表
export async function addsaveKq(params) {
    return post(attendanceserver+'/kq/addsaveKq', params, true)
}